import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

const SimpleModal = ({
  children,
  extraStyle,
  hasPadding,
  onClose,
  show,
  title,
  variant,
  variantContent,
}) => {
  useEffect(() => {
    show
      ? document.addEventListener('keydown', onEscape)
      : document.removeEventListener('keydown', onEscape)
    return () => document.removeEventListener('keydown', onEscape)
  }, [show])

  const onEscape = ({ keyCode }) => {
    if (keyCode === 27) {
      onClose()
    }
  }

  return (
    <div
      className={`the-modal big modal ${
        hasPadding ? '' : 'modal--no-padding'
      } ${show ? 'show' : ''}`}
      data-modal={`modal-${title}`}
      style={extraStyle}
    >
      <div className={`simplemodal__popup ${variant}`}>
        <div className="simplemodal__popup__header">
          <h3 className="simplemodal__popup__title">{title}</h3>
          {onClose && (
            <div className="simplemodal__popup__close" onClick={onClose}>
              <i className="icon-close" />
            </div>
          )}
        </div>
        <hr />
        <div className={`simplemodal__popup__content ${variantContent}`}>
          {children}
        </div>
      </div>
    </div>
  )
}

SimpleModal.defaultProps = {
  extraStyle: {},
  hasPadding: true,
  variant: '',
  variantContent: '',
}

SimpleModal.propTypes = {
  children: PropTypes.element.isRequired,
  extraStyle: PropTypes.object,
  hasPadding: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  variant: PropTypes.string,
  variantContent: PropTypes.string,
}

export default SimpleModal
